import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatLocalDateKey } from "../../../utils/dateUtils";

/**
 * Modal for adding a new unavailable date - using native date input instead of MUI DatePicker
 */
const UnavailableDateModal = ({ open, onClose, onConfirm }) => {
  const [selectedDate, setSelectedDate] = useState("");

  const handleConfirm = () => {
    if (selectedDate) {
      // Convert the string date to a Date object and format it properly
      const dateObj = new Date(selectedDate);
      const formattedDate = formatLocalDateKey(dateObj);
      onConfirm(formattedDate);
      setSelectedDate(""); // Reset the date for next time
    }
  };

  const handleClose = () => {
    onClose();
    setSelectedDate(""); // Reset the date when modal is closed
  };

  // Get tomorrow's date for min attribute
  const getTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "#444349",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Ajouter une date indisponible
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ color: "#676767" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 3, color: "#676767" }}>
            Sélectionnez une date qui ne sera pas disponible pour les
            réservations:
          </Typography>

          <TextField
            label="Date"
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: getTomorrow(),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            color: "#676767",
            borderColor: "#676767",
            "&:hover": {
              borderColor: "#444349",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            borderRadius: "8px",
            textTransform: "none",
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!selectedDate}
          sx={{
            backgroundColor: "#c84653",
            "&:hover": {
              backgroundColor: "#a93a46",
            },
            borderRadius: "8px",
            textTransform: "none",
          }}
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnavailableDateModal;
